module.exports = __webpack_public_path__ + "img/sld_acdb_panel_dark.d5df9edd.svg";